import { Box, Button, Chip, Grid, Pagination, Paper, Skeleton, Stack, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import AvantLandingLogo from '../images/avant_landing_logo.svg'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { FetchAgentCommissions } from '../libs/hooks/queries'
import { AuthContext } from '../libs/contexts/authContext'
import CryptoJS from 'crypto-js'
import ErrorAlert from '../Layouts/ErrorAlert'

const Commissions = () => {
  const [commissionData, setCommissionData] = useState({
    1: [],
  })
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [error, setError] = useState({
    msgText: '',
    msgTitle: '',
  })
  const [showError, setShowError] = useState(false)

  const { affiliateCode } = useContext(AuthContext)
  const { data, isLoading, isError, error: fetchingError } = FetchAgentCommissions({ affiliateCode })

  useEffect(() => {
    if (!data || !data.commissions) return
    // console.log(duplicateElements(data.commissions, 12))
    // const rows = duplicateElements(
    // data.commissions.map((i) => {
    //   return {
    //     ...i,
    //     link: decryption(i.link),
    //   }
    // }),
    //   8
    // )

    const paginated = paginateArray(
      data.commissions.map((i) => {
        return {
          ...i,
          link: decryption(i.link),
        }
      }),
      10
    )
    setTotalPages(Object.keys(paginated).length)
    setCommissionData(paginated)
  }, [data])

  useEffect(() => {
    if (!isError) return
    setShowError(true)
    setError({
      msgText: fetchingError.msgText,
      msgTitle: fetchingError.msgTitle,
    })
  }, [isError, fetchingError])

  function decryption(url) {
    url = url && url.replace(/[\r\n]/g, '')
    var iv = CryptoJS.enc.Utf8.parse('1234567812345678')
    var key = CryptoJS.enc.Utf8.parse('1234567812345678')
    var decrypted = CryptoJS.AES.decrypt(url, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
    })

    const newUrl = decrypted.toString(CryptoJS.enc.Utf8)
    return newUrl
  }

  function duplicateElements(arr, times) {
    return arr.flatMap((item) => Array(times).fill(item))
  }

  function paginateArray(arr, itemsPerPage) {
    const paginatedObj = {}
    let pageNumber = 1

    for (let i = 0; i < arr.length; i += itemsPerPage) {
      paginatedObj[pageNumber] = arr.slice(i, i + itemsPerPage)
      pageNumber++
    }

    return paginatedObj
  }

  return (
    <>
      <ErrorAlert
        showError={showError}
        setShowError={setShowError}
        msgTitle={error.msgTitle}
        messageText={error.msgText}
      />
      <div
        style={{
          backgroundColor: 'rgba(241, 243, 246, 1)',
          paddingTop: '100px',
          fontFamily: 'Roboto',
          minHeight: '100vh',
        }}
      >
        <Stack width={'100%'} direction={'column'} gap={1} mb={6}>
          <Typography variant="h4">Commissions</Typography>
          <Typography variant="subtitle2" sx={commStyle.subtitle}>
            Click the links to access NewBridge commission statements.
          </Typography>
        </Stack>

        <Paper elevation={3} sx={commStyle.containerBox}>
          <Box
            component="img"
            src={AvantLandingLogo}
            sx={{
              width: '40%',
              padding: 'auto 100px',
              opacity: 1,
            }}
          />
          <Typography
            variant="subtitle1"
            textAlign={'left'}
            sx={{ fontFamily: 'Roboto!important', color: '#64768C!important' }}
            mt={2}
          >
            Date
          </Typography>
          <Grid container rowGap={2}>
            {isLoading && (
              <>
                <Grid item lg={6} md={6} xs={6} sm={6} display={'flex'} alignItems={'center'} gap={3}>
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: '50%' }} />
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  xs={6}
                  sm={6}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'flex-end'}
                >
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: '30%' }} />
                </Grid>
              </>
            )}
            {commissionData[page].map((i, idx) => (
              <>
                <Grid item lg={6} md={6} xs={6} sm={6} display={'flex'} alignItems={'center'} gap={3}>
                  <Typography variant="subtitle1" textAlign={'left'} sx={{ fontFamily: 'Roboto!important' }}>
                    {i.date}
                  </Typography>
                  {(!i.link || i.link === '') && <Chip size="small" label="No Production" sx={commStyle.chip} />}
                </Grid>
                <Grid item lg={6} md={6} xs={6} sm={6} display={'flex'} justifyContent={'flex-end'}>
                  <Button
                    target="_blank"
                    href={i.link}
                    size="small"
                    sx={commStyle.openBtn}
                    variant="text"
                    endIcon={<KeyboardArrowRightIcon />}
                    disabled={!i.link || i.link === ''}
                  >
                    Open
                  </Button>
                </Grid>
              </>
            ))}
          </Grid>
          <Box sx={commStyle.paginator}>
            <Pagination count={totalPages} onChange={(e, v) => setPage(v)} variant="outlined" shape="rounded" />
          </Box>
        </Paper>
        {/* Your component JSX goes here */}
      </div>
    </>
  )
}

const commStyle = {
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    gap: 1,
    width: { lg: '626px', md: '770px', sm: '770px', xs: '343px' },
    maxWidth: { lg: '522px', md: '770px', sm: '770px', xs: '343px' },
    height: 'auto',
    background: '#FFFF',
    margin: 'auto',
    padding: '20px',
  },
  subtitle: {
    fontFamily: 'Roboto!important',
    fontWeight: '400!important',
    fontSize: '16px!important',
    color: '#64768C',
  },
  openBtn: {
    fontFamily: 'Roboto!important',
    fontWeight: '400!important',
    fontSize: '14px!important',
    textTransform: 'none',
  },
  chip: {
    borderRadius: '7px',
    fontSize: '12px',
    color: '#9F232B',
    backgroundColor: '#F9E0E0',
    fontWeight: '600',
  },
  paginator: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}

export default Commissions
